import {PlanetSurface} from "./planetSurface.js";
import {Globals} from "../../../../global/globals.js";

export class PlanetSurfaceTexture extends PlanetSurface {
    /**
     * Construct a textured planet surface
     * @param {string} asset The texture asset
     */
    constructor(asset) {
        super();

        this.asset = asset;
        this.loadedTexture = null;
    }

    /**
     * Load the planet surface
     * @param {WebGLRenderer} renderer The renderer
     * @returns {Promise} A promise that resolves when this surface is usable
     */
    load(renderer) {
        return new Promise(resolve => {
            Globals.TEXTURE_CACHE.load(this.asset).then(texture => {
                this.loadedTexture = texture;

                const canvas = document.createElement("canvas");
                const context = canvas.getContext("2d");

                canvas.width = texture.image.width;
                canvas.height = texture.image.height;

                context.drawImage(texture.image, 0, 0);

                this.color = PlanetSurface.getAverageImageColor(context, canvas.width, canvas.height);

                resolve();
            });
        });
    }

    /**
     * Get the surface texture
     * @returns {Texture} The surface texture
     */
    get texture() {
        return this.loadedTexture;
    }
}